import { sessaoFetch } from '@/service/fetch'

export async function list () {
  return sessaoFetch('base', `/produto`)
}

export async function cTabela () {
  return sessaoFetch(`base`, `/produto/tabela/comissionamento`, 'GET')
}

export async function cContrato () {
  return sessaoFetch(`base`, `/produto/list/contrato`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/produto.js